const hallImg = {};

["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"].forEach(id => {
  hallImg[`hall_${id}`] = require(`./img/hall/hall_${id}.png`);
});

const timeImg = {};

for (let i = 0; i <= 9; i++) {
  timeImg[`time_${i}`] = require(`./img/time/time-${i}.png`);
}

export { hallImg, timeImg };
